import { gql } from '@apollo/client';

export const GET_PROGRAMME_DATES = gql`
  query GetProgrammeDates($id: ID!) {
    programme: getProgrammeDates(id: $id) {
      id
      name
      fromDate
      toDate
    }
  }
`;
